import "./404.css";
function C404(){
    return (
        <div className={"C404"}>
            <h4>404 | Page Not Found</h4>
        </div>
    );
}

export default C404;